import { getApiEndpoint } from '../utils/api-url';

export class AdminAPI {
  // Em produção no Cloudflare Pages, usa VITE_API_URL (Render)
  // Em desenvolvimento local, usa /api (com proxy do Vite)

  static async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = getApiEndpoint(endpoint);
    
    try {
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
        ...options,
      });

      // Verificar se a resposta é JSON válido
      if (!response.ok) {
        const errorText = await response.text();
        try {
          const errorData = JSON.parse(errorText);
          throw new Error(errorData.error || `HTTP ${response.status}`);
        } catch {
          throw new Error(errorText || `HTTP ${response.status}`);
        }
      }

      const data = await response.json();
      return data;
    } catch (error: any) {
      console.error(`Erro na requisição ${url}:`, error);
      throw error;
    }
  }

  static get<T>(endpoint: string): Promise<T> {
    return this.request<T>(endpoint);
  }

  static post<T>(endpoint: string, data: any): Promise<T> {
    return this.request<T>(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  static put<T>(endpoint: string, data: any): Promise<T> {
    return this.request<T>(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  static delete<T>(endpoint: string): Promise<T> {
    return this.request<T>(endpoint, { method: 'DELETE' });
  }
}

